var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2507_90454)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0492 24.0005C2.55701 24.0005 0.210449 21.654 0.210449 18.1618V7.10242C0.210449 3.61023 2.55696 1.26367 6.0492 1.26367H17.9507C21.4429 1.26367 23.7894 3.61019 23.7894 7.10242V18.1618C23.7894 21.654 21.4429 24.0005 17.9507 24.0005H6.0492Z",
    fill: "#64748B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.0492 23.5787C2.55701 23.5787 0.210449 21.2321 0.210449 17.7399V6.68055C0.210449 3.18836 2.55696 0.841797 6.0492 0.841797H17.9507C21.4429 0.841797 23.7894 3.18831 23.7894 6.68055V17.7399C23.7894 21.2321 21.4429 23.5787 17.9507 23.5787H6.0492Z",
    fill: "url(#paint0_linear_2507_90454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.210449 6.73656V6.68055C0.210449 3.18836 2.55696 0.841797 6.0492 0.841797H17.9507C21.4429 0.841797 23.7894 3.18831 23.7894 6.68055V6.73656H0.210449Z",
    fill: "#F4413D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9507 0.841797H6.0492C2.55701 0.841797 0.210449 3.18831 0.210449 6.68055V17.7399C0.210449 21.2321 2.55696 23.5787 6.0492 23.5787H17.9507C21.4429 23.5787 23.7894 21.2321 23.7894 17.7399V6.68055C23.7894 3.18831 21.4429 0.841797 17.9507 0.841797ZM22.9473 17.7399C22.9473 20.7753 20.9861 22.7365 17.9507 22.7365H6.0492C3.01381 22.7365 1.05256 20.7753 1.05256 17.7399V6.68055C1.05256 3.64516 3.01381 1.68391 6.0492 1.68391H17.9507C20.9861 1.68391 22.9473 3.64516 22.9473 6.68055V17.7399Z",
    fill: "url(#paint1_linear_2507_90454)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.45327 13.8461H9.42044C10.5085 13.8461 11.2566 13.1784 11.2566 12.2516C11.2566 11.3535 10.5775 10.7202 9.45494 10.7202C8.42463 10.7202 7.69324 11.3421 7.60694 12.263H6.84696C6.94464 10.9274 7.99263 10.0293 9.48907 10.0293C10.9514 10.0293 12.0507 10.9215 12.0507 12.1535C12.0507 13.1956 11.3771 13.9438 10.3181 14.1337V14.1568C11.5901 14.2318 12.4078 15.0204 12.4078 16.1947C12.4078 17.5993 11.153 18.601 9.53538 18.601C7.86002 18.601 6.72611 17.6453 6.67432 16.3156H7.4343C7.49744 17.2423 8.33243 17.9101 9.52989 17.9101C10.7328 17.9101 11.6082 17.2019 11.6082 16.2175C11.6082 15.1581 10.7909 14.5135 9.45536 14.5135H8.45369C8.45327 14.5139 8.45327 13.8461 8.45327 13.8461Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 10.9963H15.7009C15.5687 11.0767 14.1296 12.1188 13.4731 12.5277V11.6872C13.7207 11.5318 15.482 10.2885 15.7123 10.1504H16.4837V18.4687H15.7237L15.7241 10.9963Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M5.68404 5.05167C6.38165 5.05167 6.94718 4.48614 6.94718 3.78853C6.94718 3.09092 6.38165 2.52539 5.68404 2.52539C4.98643 2.52539 4.4209 3.09092 4.4209 3.78853C4.4209 4.48614 4.98643 5.05167 5.68404 5.05167Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M18.3159 5.05167C19.0135 5.05167 19.579 4.48614 19.579 3.78853C19.579 3.09092 19.0135 2.52539 18.3159 2.52539C17.6183 2.52539 17.0527 3.09092 17.0527 3.78853C17.0527 4.48614 17.6183 5.05167 18.3159 5.05167Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9507 0.841797H6.0492C2.55701 0.841797 0.210449 3.18831 0.210449 6.68055V17.7399C0.210449 21.2321 2.55696 23.5787 6.0492 23.5787H17.9507C21.4429 23.5787 23.7894 21.2321 23.7894 17.7399V6.68055C23.7894 3.18831 21.4429 0.841797 17.9507 0.841797ZM23.3683 17.7399C23.3683 20.9803 21.1911 23.1576 17.9507 23.1576H6.0492C2.80878 23.1576 0.631527 20.9803 0.631527 17.7399V6.68055C0.631527 3.44012 2.80878 1.26287 6.0492 1.26287H17.9507C21.1911 1.26287 23.3683 3.44012 23.3683 6.68055V17.7399Z",
    fill: "#64748B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.68421 4.21055C5.45181 4.21055 5.26318 4.02192 5.26318 3.78952V0.421031C5.26318 0.188625 5.45181 0 5.68421 0C5.91662 0 6.10525 0.188625 6.10525 0.421031V3.78947C6.10529 4.02187 5.91662 4.21055 5.68421 4.21055Z",
    fill: "url(#paint2_linear_2507_90454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3161 4.21055C18.0836 4.21055 17.895 4.02192 17.895 3.78952V0.421031C17.895 0.188625 18.0836 0 18.3161 0C18.5485 0 18.7371 0.188625 18.7371 0.421031V3.78947C18.7371 4.02187 18.5485 4.21055 18.3161 4.21055Z",
    fill: "url(#paint3_linear_2507_90454)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2507_90454",
    x1: 11.9999,
    y1: 23.5774,
    x2: 11.9999,
    y2: 0.840484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2507_90454",
    x1: 11.9999,
    y1: 23.5774,
    x2: 11.9999,
    y2: 0.840484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2507_90454",
    x1: 5.68417,
    y1: 4.20923,
    x2: 5.68417,
    y2: -0.00131281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2507_90454",
    x1: 18.3161,
    y1: 4.20923,
    x2: 18.3161,
    y2: -0.00131281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2507_90454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3bfa896fb20f84f65220543569115ad2.svg";
export { ForwardRef as ReactComponent };